import { Breadcrumb } from "antd";
import styled from "styled-components";

export const BreadcrumbWrapper = styled(Breadcrumb)`
  font-size: 0.9rem;
  font-weight: 500;
  border-bottom: 2px solid #e8e8e8;
  height: 2rem;
  line-height: 2rem;
  padding: 0 0.5rem;
  a {
    height: 100%;
  }
`;
